import React from 'react';

interface Props {
  className?: string;
}

export const UnreadDot: React.FC<Props> = ({ className }) => (
  <span
    className={`size-1.5 shrink-0 rounded-full bg-accent ${className ?? ''}`}
  />
);
